const DATABASE_NAME = "@h4money";

const COLLECTION_USERS = `${DATABASE_NAME}:users`;
const COLLECTION_ACCESS = `${DATABASE_NAME}:access`;
const COLLECTION_CARTAO = `${DATABASE_NAME}:cartao`;
const COLLECTION_APPOINTMENTS = `${DATABASE_NAME}:appointments`;
const COLLECTION_TOKEN = `${DATABASE_NAME}:token`;

export { COLLECTION_APPOINTMENTS, COLLECTION_USERS, COLLECTION_CARTAO, COLLECTION_ACCESS, COLLECTION_TOKEN };
